import { digit2string, lastElement } from '@sitecore-search/common';
import { getConfigProperty, getDomainHost, getServiceConfig } from '../config.js';
import { DEVICE, THREE_YEARS, TIME } from '../constants.js';
import { extractDomain } from '../index.js';
import RfkStorage from '../utils/storage.js';
// exported for test purposes
export const SITE_INFO = {};
export const getDomainKey = () => {
    const { domainId, customerKey } = getServiceConfig();
    if (customerKey) {
        return extractDomain(customerKey);
    }
    return domainId;
};
const getDomainUid = () => {
    let uid = RfkStorage.get('__ruid');
    if (uid) {
        return uid;
    }
    const uidx = 'xx-xx-4x-1' + DEVICE[0] + '-'; // pattern of prefix to user id
    uid = uidx.replace(/[x]/g, () => digit2string((Math.random() * 36) | 0));
    for (let i = 0; i < 5; i++) {
        uid += ('0000' + ((Math.random() * 1679615) | 0).toString(36)).slice(-4);
    }
    const value = getDomainKey() + '-' + uid + '-' + TIME;
    RfkStorage.set('__ruid', value);
    return value;
};
const generateNewUTMA = (utma, isNewSession) => {
    const utmaAttributes = utma.split('.');
    if (utmaAttributes.length > 3) {
        if (isNewSession) {
            // update previous time, current time, and visit count
            utmaAttributes[1] = utmaAttributes[2]; // replace previous time with current time
            utmaAttributes[2] = TIME; // update current time
            utmaAttributes[3] = utmaAttributes[3] * 1 + 1; // update visit count
        }
        if (utmaAttributes.length === 4) {
            // without page view count
            utmaAttributes[4] = 1;
        }
        if (utmaAttributes.length === 5) {
            // without visit page count
            utmaAttributes[5] = 1;
        }
        utmaAttributes[4] = utmaAttributes[4] * 1 + 1; // update page view count
        utmaAttributes[5] = 1 + (isNewSession ? 0 : utmaAttributes[5] * 1); // update visit page count
        // update utma
        utma = utmaAttributes.join('.');
    }
    return utma;
};
const getUTMA = () => {
    let isNewSession = 0;
    let utma = RfkStorage.get('__rutma');
    const utmb = RfkStorage.get('__rutmb');
    if (!utmb) {
        RfkStorage.set('__rutmb', getDomainKey(), THREE_YEARS);
        isNewSession = 1;
    }
    if (utma) {
        utma = generateNewUTMA(utma, isNewSession);
    }
    else {
        // uid.previousSessionTime.currentSessionTime.visit-count.page-count.visit-page-count
        // if rfkP.uid is available, it will be used otherwise create a new one
        // _time should be set when the sdk starts loading
        utma = `${getDomainUid()}.${TIME}.${TIME}.1.1.1`;
    }
    RfkStorage.set('__rutma', utma, THREE_YEARS);
    return utma;
};
export const getSiteInfo = () => {
    const { domainHash } = getServiceConfig();
    SITE_INFO.domainHashCkey = domainHash; // domain hash from ckey
    SITE_INFO.domainHash = SITE_INFO.domainHashCkey; // domain_hash needs to be set before utma
    SITE_INFO.domainRoot = getDomainHost(); // domain root
    const utma = getUTMA(); // to be after domain_hash
    const utmaParts = utma.split('.');
    SITE_INFO.uid = utmaParts[0];
    SITE_INFO.usetLastDigit = lastElement(utmaParts[0]); // user (last) digit of cookie creation time
    SITE_INFO.previousSessionStartTime = parseInt(utmaParts[1]); // previousSessionStartTime
    SITE_INFO.currentSessionStartTime = parseInt(utmaParts[2]); // currentSessionStartTime
    SITE_INFO.visitCount = parseInt(utmaParts[3]); // visitCount
    SITE_INFO.pageViewCount = parseInt(utmaParts[4]); // pageViewCount
    SITE_INFO.visitPageCount = parseInt(utmaParts[5]); // visit page count
    SITE_INFO.utma = utma; // old one, we have to update backend
    return SITE_INFO;
};
export const getUserId = () => {
    const customerUserId = getConfigProperty('userId');
    if (customerUserId) {
        return { user_id: customerUserId };
    }
    const { uid } = getSiteInfo();
    return {
        uuid: uid,
    };
};
export const resetUserId = () => {
    RfkStorage.remove('__ruid');
    RfkStorage.remove('__rutma');
    RfkStorage.remove('__rutmb');
    RfkStorage.remove('__ec');
};
